import type { Availability, ChatMessage, EvaSession, Poll, PollOption, PollVote, Profile, Registration } from "./types";

export const currentDemoUserId = "u1";

export const profiles: Profile[] = [
  { id: "u1", display_name: "Nova", role: "admin" },
  { id: "u2", display_name: "Raptor", role: "player" },
  { id: "u3", display_name: "Echo", role: "player" },
  { id: "u4", display_name: "Kira", role: "player" },
  { id: "u5", display_name: "Pulse", role: "player" },
  { id: "u6", display_name: "Valk", role: "player" }
];

export const sessions: EvaSession[] = [
  {
    id: "s1",
    title: "Training squad Alpha",
    center: "EVA Lyon",
    starts_at: "2026-05-09T19:30:00+02:00",
    duration_minutes: 40,
    capacity: 6,
    expert: true,
    notes: "Objectif scrim, composition stable.",
    source: "manual"
  },
  {
    id: "s2",
    title: "Session decouverte equipe",
    center: "EVA Grenoble",
    starts_at: "2026-05-11T20:00:00+02:00",
    duration_minutes: 40,
    capacity: 8,
    expert: false,
    notes: "Ouvert aux remplacants.",
    source: "manual"
  },
  {
    id: "s3",
    title: "Bloc tactique",
    center: "EVA Lyon",
    starts_at: "2026-05-14T18:45:00+02:00",
    duration_minutes: 80,
    capacity: 6,
    expert: true,
    notes: "Deux parties consecutives.",
    source: "manual"
  },
  {
    id: "eva_75_37353a_demo_2026_05_07_2000_155",
    title: "EVA BATTLE ARENA",
    center: "EVA location 75",
    starts_at: "2026-05-07T20:00:00+02:00",
    duration_minutes: 40,
    capacity: 10,
    expert: false,
    notes: "Session synchronisee depuis EVA.",
    source: "eva",
    eva_location_id: 75,
    eva_slot_id: "37353a_demo_2026_05_07_2000",
    eva_terrain_id: 155,
    eva_game_name: "EVA BATTLE ARENA",
    eva_taken_seat_count: 9,
    eva_available_seat_count: 1,
    eva_synced_at: "2026-05-07T12:10:00+02:00"
  }
];

export const registrations: Registration[] = [
  { id: "r1", session_id: "s1", player_id: "u1", status: "registered" },
  { id: "r2", session_id: "s1", player_id: "u2", status: "registered" },
  { id: "r3", session_id: "s1", player_id: "u3", status: "registered" },
  { id: "r4", session_id: "s1", player_id: "u4", status: "registered" },
  { id: "r5", session_id: "s2", player_id: "u2", status: "registered" },
  { id: "r6", session_id: "s2", player_id: "u5", status: "registered" },
  { id: "r7", session_id: "s3", player_id: "u1", status: "registered" },
  { id: "r8", session_id: "s3", player_id: "u2", status: "registered" },
  { id: "r9", session_id: "s3", player_id: "u3", status: "registered" },
  { id: "r10", session_id: "s3", player_id: "u4", status: "registered" },
  { id: "r11", session_id: "s3", player_id: "u5", status: "registered" },
  { id: "r12", session_id: "s3", player_id: "u6", status: "registered" }
];

export const availability: Availability[] = [
  { id: "a1", player_id: "u1", weekday: 2, start_time: "18:00", end_time: "22:30" },
  { id: "a2", player_id: "u1", weekday: 4, start_time: "18:00", end_time: "21:00" },
  { id: "a3", player_id: "u2", weekday: 6, start_time: "14:00", end_time: "23:00" },
  { id: "a4", player_id: "u2", weekday: 1, start_time: "19:00", end_time: "22:00" },
  { id: "a5", player_id: "u3", weekday: 6, start_time: "18:00", end_time: "22:00" },
  { id: "a6", player_id: "u3", weekday: 4, start_time: "18:30", end_time: "21:30" },
  { id: "a7", player_id: "u4", weekday: 6, start_time: "18:00", end_time: "21:00" },
  { id: "a8", player_id: "u5", weekday: 1, start_time: "19:30", end_time: "22:30" },
  { id: "a9", player_id: "u6", weekday: 4, start_time: "18:00", end_time: "23:00" }
];

export const messages: ChatMessage[] = [
  { id: "m1", player_id: "u2", content: "Qui est dispo pour Lyon samedi ?", created_at: "2026-05-07T12:00:00+02:00" },
  { id: "m2", player_id: "u1", content: "Je bloque une session expert si on atteint 6 joueurs.", created_at: "2026-05-07T12:02:00+02:00" },
  { id: "m3", session_id: "s1", player_id: "u3", content: "OK pour moi, je peux arriver 15 min avant.", created_at: "2026-05-07T12:05:00+02:00" }
];

export const polls: Poll[] = [
  { id: "p1", title: "Meilleur creneau pour la prochaine session ?", closes_at: "2026-05-10T22:00:00+02:00" }
];

export const pollOptions: PollOption[] = [
  { id: "po1", poll_id: "p1", label: "Lundi 20h - EVA Grenoble" },
  { id: "po2", poll_id: "p1", label: "Jeudi 18h45 - EVA Lyon" },
  { id: "po3", poll_id: "p1", label: "Samedi 19h30 - EVA Lyon" }
];

export const pollVotes: PollVote[] = [
  { id: "pv1", poll_id: "p1", option_id: "po2", player_id: "u1" },
  { id: "pv2", poll_id: "p1", option_id: "po3", player_id: "u2" },
  { id: "pv3", poll_id: "p1", option_id: "po3", player_id: "u3" }
];
